import { ProductUseValidity } from "src/app/ui/models/domains/pbm/product-management/product-use-validity";
import { AbstractParser } from "../../parser";
import { parseProductUseValidities } from "./product-management-parse-funtions";

export class ProductUseValiditiesParser extends AbstractParser<ProductUseValidity[]> {
  public parse(payload: any): ProductUseValidity[] {
    return parseProductUseValidities(payload);
  }
}
